import React from 'react';

import ConfirmDialog from '../../../../components/ConfirmDialog';
import { LIVE_STREAM_NS } from './Defs';

export interface LiveStreamExitConfirmDialogProps {
    open: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

const LiveStreamExitConfirmDialog: React.FC<LiveStreamExitConfirmDialogProps> = ({ open, onCancel, onConfirm }) => (
    <ConfirmDialog
        isDialogOpen={open}
        isLoading={false}
        headerText={`${LIVE_STREAM_NS}.exit_confirm_title`}
        bodyText={[`${LIVE_STREAM_NS}.exit_confirm_message`]}
        buttonText={`${LIVE_STREAM_NS}.exit_confirm_end`}
        buttonColor="redColor"
        cancelText={`${LIVE_STREAM_NS}.exit_confirm_cancel`}
        onClose={onCancel}
        onCancel={onCancel}
        onConfirm={onConfirm}
    />
);

export default LiveStreamExitConfirmDialog;
